import Column from '@components/column'
import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleContacts = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    margin-top: 20px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 0px;
  }
`
export const EachContact = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid ${theme.colors.borderBlue};
  gap: 12px;
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    &:hover {
      transform: none;
    }
    padding: 14px;
    font-size: 12px;
  }
  @media (max-width: 380px) {
    padding: 14px;

    font-size: 10px;
  }
`
export const SupportAgentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  max-width: 1200px;
  width: 100%;
  border-radius: 12px;
  border: 1px solid ${theme.colors.borderBlue};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  @media (max-width: 640px) {
    flex-direction: column;
    padding: 20px 0px;

    &:hover {
      transform: none;
    }
  }
`

export const AgentImageWrapper = styled.div`
  width: 54px;
  height: 54px;
`
export const AgentIconWrapper = styled.div`
  &:hover {
    transform: scale(1.05);
  }
`
export const AgentColumn = styled(Column)<any>`
  @media (max-width: 640px) {
    align-items: center;
    padding: 0px;
    padding-bottom: ${(props) => (props.pb ? '8' : '0')}px;
    padding-top: ${(props) => (props.pt ? '8' : '0')}px;

    border-bottom: ${(props) =>
      props.hasBorder ? `0.5px solid ${props.theme.colors.primary}` : ''};
  }
`
